import {Alert} from 'bootstrap'
const list = ["danger","success","warning","light","info"]
export function showToast(type, message,delay) {
    if(!type || !list.includes(type)){
        type = "primary" // danger、success、warning、light、info
    }
    if(!delay || isNaN(delay)){
        delay = 2000
    }
// 创建Toast元素
const toast = document.createElement('div');
toast.innerHTML = `
  <div class="alert alert-${type} text-center slide-in-top py-3 position-fixed  d-flex align-items-center justify-content-between" style="
margin: auto;
  /*top: 50%;*/
  position: absolute;
  justify-content: center;
  align-items: center;
  top:50px;
  z-index: 9999;
  width: 80%;
  max-width: 400px;
  min-width: 300px;
  left: 0;
  right: 0;
  word-break: break-all" 
  role="alert" >
    <text class="flex-fill text-center">${message || '出错啦'}</text>
<!--    <button type="button"  class="btn-close  m-2" data-bs-dismiss="alert" aria-label="Close"></button>-->
 <button type="button "  class="btn-close mx-2 px-2 flex-shrink-0" data-bs-dismiss="alert" @click="close"></button>
  </div>

`
// 将Toast添加到页面上
document.body.appendChild(toast);
const bsAlert = new Alert(toast)
// 如果有关闭时间
    setTimeout(()=>{
        bsAlert.close()
        toast.remove()
    },delay)
}


